import { IconTile } from "@design";
import { Globe, Plug } from "lucide-react";

/** Neutral tile: a plug for MCP servers, a globe for API endpoints. */
export function ConnectorIcon({ transport }: Readonly<{ transport: string }>) {
  return (
    <IconTile variant="neutral">
      {transport === "http" ? <Globe size={16} aria-hidden /> : <Plug size={16} aria-hidden />}
    </IconTile>
  );
}
